import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";

const ConfirmRewardCRM = props => {
	const classes = useStyles();
	const { isSignRewardConfirm, setConfirmReward } = props;

	return (
		isSignRewardConfirm && (
			<Grid style={{ padding: "10px 16px 0px" }}>
				<Grid
					component="button"
					classes={{ root: classes.rootBtn }}
					onClick={() => {
						setConfirmReward(true);
					}}
				>
					<Grid
						classes={{ root: classes.button }}
						container
						alignItems="center"
					>
						<Grid classes={{ root: classes.logo }}>
							<img
								src={Images.icConfirmCRM}
								alt={"icConfirmCRM"}
							/>
							Xác nhận nhận thưởng CRM
						</Grid>
						<img src={Images.icArrowForward} alt="icArrowForward" />
					</Grid>
				</Grid>
			</Grid>
		)
	);
};

export default memo(ConfirmRewardCRM);
